var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardInvoicePaymentDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.2379,
    cy: 16.0322,
    r: 15.5596,
    fill: "#F0B64F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8827 9.60938C10.1831 9.60938 9.51221 9.88727 9.01755 10.3819C8.52289 10.8766 8.245 11.5475 8.245 12.247V13.1263H24.6571V12.247C24.6571 11.5475 24.3792 10.8766 23.8846 10.3819C23.3899 9.88727 22.719 9.60938 22.0195 9.60938H10.8827ZM8.245 19.867V14.2986H24.6571V19.867C24.6571 20.5665 24.3792 21.2374 23.8846 21.7321C23.3899 22.2267 22.719 22.5046 22.0195 22.5046H10.8827C10.1831 22.5046 9.51221 22.2267 9.01755 21.7321C8.52289 21.2374 8.245 20.5665 8.245 19.867ZM19.3818 17.8154C19.2264 17.8154 19.0773 17.8772 18.9673 17.9871C18.8574 18.0971 18.7957 18.2461 18.7957 18.4016C18.7957 18.5571 18.8574 18.7061 18.9673 18.8161C19.0773 18.926 19.2264 18.9877 19.3818 18.9877H21.1403C21.2957 18.9877 21.4448 18.926 21.5547 18.8161C21.6646 18.7061 21.7264 18.5571 21.7264 18.4016C21.7264 18.2461 21.6646 18.0971 21.5547 17.9871C21.4448 17.8772 21.2957 17.8154 21.1403 17.8154H19.3818Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardInvoicePaymentDone);
export default __webpack_public_path__ + "static/media/dashboard_invoice_payment_done.b9e4167ad3444e41a9499d06a819b64e.svg";
export { ForwardRef as ReactComponent };